<style>
.list-group-item2 {
    position: relative;
    /* display: block; */
    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
    color: var(--bs-list-group-color);
    text-decoration: none;
    background-color: var(--bs-list-group-bg);
    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
</style>
<template>
    <div class="app-layout">
        <!-- Componente de la barra de navegación -->
        <!-- Componente de la barra de navegación -->
        <NavBar :collapsed="collapsed" :pinned="pinned" @update:collapsed="updateCollapsed"
            @update:pinned="updatePinned" />
        <!-- Contenido principal -->

        <main :class="{ 'main-collapsed': collapsed, 'main-expanded': !collapsed || pinned }">
            <BarTop />
            <div class="" style="padding: 4rem;">
                <div class="py-4 ">
                    <div>
                        <h2 class="fw-normal mb-4 me-3">
                            <b>{{ edit_mode ? ('Editando nota de cobro #' + edit_id) : 'Crear nota de cobro' }}</b>
                        </h2>
                        <p>Una nota de cobro contiene un listado de pagos a proveedor (gastos) que serán enviados
                            como cobranza a un cliente. </p>
                    </div>
                    <div class="row pt-4 px-1">

                        <div class="col-4 mb-4">
                            <label for="client" class="form-label">Seleccionar cliente</label>
                            <select :disabled="edit_mode" @change="clientSelected($event)" class="form-select"
                                aria-label="Default select example" v-model="dataForm.client.value">
                                <option v-for="client in clients" :value="client.id_client">{{ client.name }}
                                </option>
                            </select>
                            <span v-if="dataForm.client.err" class="text-danger">Debe seleccionar un cliente</span>
                        </div>

                    </div>
                    <div class="row pt-4 px-1">
                        <div class="col-4 mb-4">
                            <label for="date_emit" class="form-label">Fecha de emisión (seleccionar solo si va a crear y
                                emitir)</label>
                            <div class="input-group mb-3">
                                <VueDatePicker v-model="dataForm.date_emit.value" locale="es" format="dd/MM/yyyy">
                                </VueDatePicker>
                            </div>
                            <span v-if="dataForm.date_emit.err" class="text-danger">Debe escoger una fecha</span>
                        </div>
                    </div>
                    <div class="row pt-0 px-1">

                        <div class="col-4 mb-4">
                            <label for="currency" class="form-label">Seleccionar divisa</label>
                            <select class="form-select" aria-label="Default select example"
                                v-model="dataForm.currency.value" @change="formatAmountAndUpdate(dataForm.billing_note_amount,
            dataForm.currency)">
                                <option v-for="currency in currencies" :value="currency.id_currency">{{ currency.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-4 mb-4">
                            <label for="numberBill" class="form-label">Número de documento</label>
                            <input type="text" class="form-control"
                                :class="{ 'border-danger': dataForm.numberBill.err }" id="numberBill" placeholder=""
                                v-model="dataForm.numberBill.value" @blur="handlerBlur">
                            <span v-if="dataForm.numberBill.err" class="text-danger">Debe ingresar un número de nota de
                                cobro</span>
                        </div>


                    </div>

                    <div class="row pt-4 px-1">
                        <div class="col-4 mb-4">
                            <label for="billing_note_amount" class="form-label">Monto</label>
                            <input type="text" class="form-control" disabled
                                :class="{ 'border-danger': dataForm.billing_note_amount.err }" id="billing_note_amount"
                                placeholder="" v-model="dataForm.billing_note_amount.value_formated" @input="formatAmountAndUpdate(dataForm.billing_note_amount,
            dataForm.currency)" @blur="handlerBlur">
                            <span v-if="dataForm.billing_note_amount.err" class="text-danger">Debe ingresar un
                                monto</span>
                        </div>
                    </div>
                    <div v-if="dataForm.pagoserr == false" class="text-dark">Pagos a proveedor asociados:
                        <span class="text-info" v-for="(bill, ind) in selectedItems">
                            &ensp;"{{ bill.id_payment }}"
                        </span>
                    </div>
                    <br>
                    <div class="col-3">
                        <input type="text" class="form-control" v-model="search" placeholder="Buscar despacho..." />
                    </div>

                    <br>
                    <vue3-datatable :search="search" :rows="items" :columns="columns" order :sortable="true"
                        :sortColumn="'date_payment'">
                        <template #select="data">
                            <button @click="toggleSelection(data.value)">
                                {{ isSelected(data.value) ? 'Desasociar' : 'Asociar' }}
                            </button>
                        </template>
                        <template #value_payment="data">
                            <span>{{ data.value.value_payment > 0 ? formatCurrency(data.value.value_payment,
            data.value.value_payment_initials) : 0 }}</span>
                        </template>
                        <template #unpaid_amount="data">
                            <span>{{ data.value.unpaid_amount > 0 ? formatCurrency(data.value.unpaid_amount,
            data.value.value_payment_initials) : 0 }}</span>
                        </template>
                    </vue3-datatable>
                    <div class="text-center text-lg-end mt-4 pt-2">
                        <!-- Crear -->
                        <template v-if="!edit_mode">
                            <button type="button" class="btn btn-md text-white mx-2"
                                style="padding-left: 2.5rem; padding-right: 2.5rem;background-color: #5a50e0;"
                                @click="save(true)">
                                Crear y emitir
                            </button>
                            <button type="button" class="btn btn-md text-white mx-2 bg-success"
                                style="padding-left: 2.5rem; padding-right: 2.5rem;" @click="save(false)">
                                Guardar sin emitir
                            </button>
                        </template>

                        <!-- Editar -->
                        <template v-else>
                            <button type="button" class="btn btn-md text-white mx-2"
                                style="padding-left: 2.5rem; padding-right: 2.5rem;background-color: #5a50e0;"
                                @click="save(true)">
                                Actualizar y emitir
                            </button>
                            <button type="button" class="btn btn-md text-white mx-2 bg-success"
                                style="padding-left: 2.5rem; padding-right: 2.5rem;" @click="save(false)">
                                Guardar cambios
                            </button>
                        </template>

                        <button type="button" class="btn btn-md text-white bg-danger" @click="backPage()"
                            style="padding-left: 2.5rem; padding-right: 2.5rem;">
                            Cancelar
                        </button>
                    </div>

                </div>
            </div>


        </main>

        <!-- Modal ar -->
        <div class="modal-mb" v-if="verModal">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class="modal-title text-black col-11" id="exampleModalLabel">Pagos a proveedor</h5>
                        <button type="button" class="btn-close col" data-bs-dismiss="modal" @click="closeModal()"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body mt-4">
                        <div class="card">
                            <div class="">

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            @click="closeModal()">Cerrar</button>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import Vue3Datatable from "@bhplugin/vue3-datatable";
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net";
import NavBar from './../component/NavBar.vue';
import NumUtils from './../component/NumUtils.vue';
import BarTop from './../component/BarTop.vue';

DataTable.use(DataTablesCore);

export default {
    components: {
        VueDatePicker,
        DataTable,
        DataTablesCore,
        NavBar,
        BarTop,
        NumUtils,
        Vue3Datatable
    },
    data() {
        return {
            edit_mode: false,
            edit_id: 0,
            loadedNote: null,
            collapsed: true,
            verModal: false,
            pinned: localStorage.getItem('pinned') == 'false' ? false : true || false,
            theme: localStorage.getItem('theme') || 'light-mode',
            currencies: [],
            selectedItems: new Set(),
            search: '',
            items: [

            ],
            clients: [

            ],
            columns: [
                { field: 'select', title: 'Seleccionar' },
                { field: "id_payment", title: "ID" },
                { field: "shipping_number", title: "Nro. despacho" },
                { field: "date_payment", title: "Fecha" },
                { field: "week_number", title: "Número de semana" },
                { field: "concept", title: "Concepto" },
                { field: "value_payment", title: "Monto deuda original" },
                { field: "unpaid_amount", title: "Monto impago" },
                { field: "value_payment_initials", title: "Divisa" }
            ],
            idClient: 0,
            currencySelect: '',
            dataForm: {
                sending: false,
                pagoserr: false,
                numberBill: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                date_emit: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                currency: {
                    value: 15,
                    err: false,
                },
                billing_note_amount: {
                    value: 0, // monto que efectivamente se envía a guardar
                    value_formated: 0, // monto que se muestra por pantalla (input)
                    err: false,
                },
                client: {
                    value: '',
                    err: false,
                }
            }
        }
    },
    async mounted() {

        // this.getAR()
        this.getClients();
        document.body.className = this.theme;

        const sessionData = localStorage.getItem('user');
        this.user = JSON.parse(sessionData);
        this.idClient = this.user.company.id;

        await this.getCurrencies();

        // 🔎 Detectar edición desde la URL (último segmento numérico)
        const parts = window.location.pathname.split('/').filter(Boolean);
        const last = parts[parts.length - 1];
        if (last && !isNaN(Number(last))) {
            this.edit_mode = true;
            this.edit_id = Number(last);
        }

        // Si es edición, cargar la nota y poblar el formulario
        if (this.edit_mode) {
            await this.getBillingNote(this.edit_id);  // ↓ método nuevo
        }
    },
    computed: {
        isSelected() {

            // Computed para validar si el elemento está seleccionado
            return (value) => this.selectedItems.has(value);
        }
    },
    methods: {
        formatAmount(amount, currencyId) {

            let currencyCode = currencyId;
            if (currencyCode == "" || currencyCode == 0) {
                amountInput.value = '';
                return {
                    value_formated: null,
                    value: null
                };
            }
            let monto = Number(amount);
            if (monto == NaN) {
                return {
                    value_formated: null,
                    value: null
                };
            }

            console.log(currencyCode);
            // event.target.value = 8;
            //let local = undefined; // toma el local del navegador después
            let local = 'es-CL'; // forzar fomato a puntos 
            let currency = 'CLP'
            if (currencyCode == 15) { // 15 es CLP
                //local = 'es-CL';
                currency = 'CLP';
            }
            if (currencyCode == 1) { // 1 es USD
                //local = 'en-US';
                currency = 'USD';
            }
            if (currencyCode == 2) { // 2 es Euro
                //local = 'en-US';
                currency = 'EUR';
            }

            let formateado = new Intl.NumberFormat(local, {
                style: 'decimal',
                //currencyDisplay: "narrowSymbol",
                //currencySign: "accounting",
                currency: currency,
                minimumFractionDigits: 0
            }).format(monto);


            return {
                value_formated: formateado,
                value: monto
            };

        },


        /**
        * 
        * @param amountInput el input (tipo text) con el monto, debe tener un campo "value" y un campo "formated_value"
        * @param currencySelect el select de la divisa, de tener un campo "value" con el número de divisa según la iso 4217
        */
        formatAmountAndUpdate(amountInput, currencySelect) {
            console.log(amountInput)
            let montoRaw = amountInput.value_formated.replace(/\D/g, '');
            if (montoRaw == "") {
                amountInput.value = '';
                amountInput.value_formated = '';
                return
            }
            let res = this.formatAmount(montoRaw, currencySelect.value)
            console.log(res);
            if (res['value_formated'] == null) {
                amountInput.value = '';
                amountInput.value_formated = '';
            } else {
                amountInput.value_formated = res['value_formated'];
                amountInput.value = res['value'];
            }

        },
        formatCurrency(value, currencyCode = 'CLP') {

            return new Intl.NumberFormat('es-CL', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0 // O puedes cambiar el valor según lo que necesites
            }).format(value);
        },
        backPage() {
            window.history.back();
        },
        async getCurrencies() {
            try {
                const response = await axios.get('/api/currencies', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                this.currencies = response.data.filter((divisa) => {
                    return divisa.status == 1
                });
            } catch (error) {
                console.error('Error fetching currencies:', error);
            }
        },
        toggleSelection(value) {
            const self = this
            console.log( self.dataForm.billing_note_amount.value_formated);
            console.log("entre")
            self.verModal = false;
            if (self.currencySelect == '') {
                self.currencySelect = value.value_payment_initials
            }
            if (self.currencySelect == value.value_payment_initials) {
                if (self.selectedItems.has(value)) {
                    self.selectedItems.delete(value); // Elimina el valor si está seleccionado
                    self.dataForm.billing_note_amount.value_formated = Number(self.dataForm.billing_note_amount.value_formated) - Number(value.unpaid_amount);
                    self.dataForm.billing_note_amount.value = Number(self.dataForm.billing_note_amount.value) - Number(value.unpaid_amount);
                } else {
                    self.selectedItems.add(value); // Agrega el valor si no está seleccionado
                    self.dataForm.billing_note_amount.value_formated = Number(self.dataForm.billing_note_amount.value_formated) + Number(value.unpaid_amount);
                    self.dataForm.billing_note_amount.value = Number(self.dataForm.billing_note_amount.value) + Number(value.unpaid_amount);
                    // self.verModal = true;
                }
                // Aseguramos que Vue detecte el cambio
                self.selectedItems = new Set(self.selectedItems);
            } else {
                self.$swal.fire({
                    icon: "error",
                    title: "No se pueden agregar 2 pagos con distinta divisa",
                    showConfirmButton: true,
                    confirmButtonText: "ok",
                    showCancelButton: false
                })
            }

        },

        closeModal() {
            const self = this
            self.verModal = false;
        },
        async getAR() {
            this.$swal({
                title: 'Obteniendo pago a proveedores'
            });
            this.$swal.showLoading();
            const self = this;
            let incluir_pagos_de = null;
            if (this.edit_mode) {
                incluir_pagos_de = this.edit_id;
            }

            let req = {
                page: 1,
                per_page: 5000,
                id_client: self.dataForm.client.value,
                sin_notas_de_cobro: true, // solo pagos sin notas de cobro asociadas
                incluir_pagos_de: incluir_pagos_de // en edición, incluir pagos ya asociados a esta nota
            }

            axios.post('/api/getSupplierPayments', req, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(response => {

                if (response.status == 200) {

                    self.items = response.data.data.filter((payment) => Number(payment.unpaid_amount) > 0)
                    console.log(this.items);
                    //self.clientesSelect = response.data.clienteEmpresa;
                    this.$swal.close();
                } else {
                    self.items = [];
                }
            }).catch(function (error) {

                if (error.response.statusText == 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout'
                }


            });
        },
        updateCollapsed(value) {
            // console.log('Evento recibido:', value); // Para depuración
            this.collapsed = value; // Actualiza el estado
        },
        updatePinned(value) {
            // console.log('Evento recibido pinn:', value); // Para depuración
            this.pinned = value; // Actualiza el estado
        },
        showreq(id) {
            const self = this;
            // console.log(id);
        },
        async save(isEmit) {
            const self = this;
            self.dataForm.sending = true;

            let errFound = false;
            const validateField = (field) => {
                if (field.value === '' || field.value === 0 || !field.value) {
                    field.err = true;
                    errFound = true;
                } else {
                    field.err = false;
                }
            };

            // Valida inputs (misma lógica que tenías)
            Object.keys(this.dataForm).forEach(key => {
                if (typeof this.dataForm[key] === 'object' && 'value' in this.dataForm[key]) {
                    if (isEmit) {
                        validateField(this.dataForm[key]);
                    } else {
                        // si NO emite, limpiamos fecha de emisión
                        if (key == "date_emit") {
                            this.dataForm[key].value = '';
                        } else {
                            validateField(this.dataForm[key]);
                        }
                    }
                }
            });

            const args = Array.from(this.selectedItems);
            if (args.length == 0) {
                self.dataForm.pagoserr = true;
                errFound = true;
            } else {
                self.dataForm.pagoserr = false;
            }
            if (errFound) return;

            this.$swal({ title: this.edit_mode ? 'Actualizando nota de cobro...' : 'Creando nota de cobro...' });
            this.$swal.showLoading();

            // payload
            const req = { form: self.dataForm, selectPass: args, isEmit: isEmit };

            // 🔧 Endpoints (ajusta a tus rutas reales)
            const url = this.edit_mode
                ? `/api/updateBillingNote/${this.edit_id}` // o '/api/updateBillingNote' con {id}
                : `/api/createBillingNote`;

            try {
                await axios.post(url, req, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                        'Content-Type': 'application/json'
                    }
                });

                this.$swal.fire({
                    icon: "success",
                    title: this.edit_mode ? "Nota de cobro actualizada" : "Nota de cobro guardada exitosamente",
                    confirmButtonText: "OK"
                }).then(() => window.location.href = './../../notascobro');

            } catch (err) {
                const status = err.response?.status;
                const message = err.response?.data?.message || 'Error interno, comuníquese con soporte';

                if (status === 409 || status === 422) {
                    // 409: duplicado / 422: validación simple
                    this.$swal.fire({
                        icon: status === 409 ? "warning" : "info",
                        title: message,
                        confirmButtonText: "OK"
                    });
                } else if (err.response?.statusText === 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout';
                } else {
                    this.$swal.fire({ icon: "error", title: message, confirmButtonText: "OK" });
                }
            }
        },
        create(isEmit) {
            const self = this;

            self.dataForm.sending = true;

            let errFound = false;
            const validateField = (field) => {
                if (field.value === '' || field.value === 0 || !field.value) {
                    field.err = true;
                    //console.log("vacio");
                    errFound = true;
                } else {
                    field.err = false;
                }
            };

            Object.keys(this.dataForm).forEach(key => {
                if (typeof this.dataForm[key] === 'object' && 'value' in this.dataForm[key]) {
                    //console.log(key);
                    if (isEmit) {
                        validateField(this.dataForm[key]);
                    } else {
                        // si no se está emitiendo no debe haber fecha de emisión
                        if (key == "date_emit") {
                            this.dataForm[key].value = '';
                        } else {
                            validateField(this.dataForm[key]);
                        }
                    }
                }
            });

            let args = Array.from(this.selectedItems);

            if (args.length == 0) {
                self.dataForm.pagoserr = true;
                errFound = true;
            } else {
                self.dataForm.pagoserr = false;
            }

            if (errFound) {
                return false;
            }

            this.$swal({
                title: 'Creando nota de cobro...'
            });

            this.$swal.showLoading();
            const req = { form: self.dataForm, selectPass: args, isEmit: isEmit }

            axios.post('/api/createBillingNote', req, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                }
            })
                .then(resp => {
                    self.$swal.fire({
                        icon: "success",
                        title: "Nota de cobro guardada exitosamente",
                        confirmButtonText: "OK"
                    }).then(() => window.location.href = '../notascobro')
                })
                .catch(err => {
                    const status = err.response?.status
                    const message = err.response?.data?.message || 'Error interno, comuníquese con soporte'

                    // 422 (validación) o 409 (duplicado)
                    if (status === 422 || status === 409) {
                        self.$swal.fire({
                            icon: status === 409 ? "warning" : "info",
                            title: message,
                            confirmButtonText: "OK"
                        })
                        return
                    }

                    if (err.response?.statusText === 'Unauthorized') {
                        localStorage.removeItem('accessToken')
                        window.location.href = './../../api/auth/logout'
                        return
                    }

                    self.$swal.fire({
                        icon: "error",
                        title: message,
                        confirmButtonText: "OK"
                    })
                })

        },
        async getBillingNote(id) {
            // ⚠️ Ajusta el endpoint a tu backend real si difiere
            // Esperado: { billing_note: {...}, payments: [...] }
            this.$swal({ title: 'Cargando nota de cobro...' }); this.$swal.showLoading();

            try {
                const { data } = await axios.get(`/api/billingnotes/${id}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });

                this.loadedNote = data || null;

                // Si tu backend devuelve diferente forma, ajusta aquí:
                const paymentsLinked = data?.payments || data?.billing_note_payments || [];
                console.log(data);
                console.log(paymentsLinked);
                // Poblar form y selección
                this.applyBillingNoteToForm(this.loadedNote, paymentsLinked);

                this.$swal.close();
            } catch (err) {
                this.$swal.close();
                this.$swal.fire({
                    icon: 'error',
                    title: 'No se pudo cargar la nota',
                    text: 'Verifica el ID o tu conexión.'
                });
            }
        },

        async applyBillingNoteToForm(note, paymentsLinked) {
            if (!note) return;

            // Cliente
            this.dataForm.client.value = note.id_client;
            // esto llena this.items

            // Divisa
            this.dataForm.currency.value = note.emit_id_currency ?? note.id_currency ?? 15;

            // Número documento
            this.dataForm.numberBill.value = note.billing_note_number ?? '';

            // Fecha emisión
            // (Asumimos que viene en ISO o 'YYYY-MM-DD HH:MM:SS'; VueDatePicker recibe Date)
            if (note.emit_date) {
                const dt = new Date(note.emit_date);
                this.dataForm.date_emit.value = isNaN(dt.getTime()) ? '' : dt;
            } else {
                this.dataForm.date_emit.value = '';
            }

            // Monto
            const amountRaw = Number(note.emit_amount ?? note.amount ?? 0);
            console.log(amountRaw)
            //this.dataForm.billing_note_amount.value = amountRaw;
            //this.dataForm.billing_note_amount.value_formated = amountRaw;
            console.log(this.dataForm.billing_note_amount, this.dataForm.currency)
            //this.formatAmountAndUpdate(this.dataForm.billing_note_amount, this.dataForm.currency);
            // usar tu util para formatear coherente al currency seleccionado


            // Pagos asociados (Set con los objetos de tabla)
            // 1) cargar la tabla completa de pagos del cliente

            // 2) marcar como seleccionados los payments de la nota
            //    si alguno no viene en items (por filtro), lo agregamos para que se vea.
            this.$nextTick(async () => {
                await this.getAR();
                setTimeout(() => {
                    const ids = new Set(paymentsLinked.map(p => p.id_payment ?? p.id));
                    // reset
                    this.selectedItems = new Set();

                    this.currencySelect = '';

                    // Asegurar que existan en items
                    paymentsLinked.forEach(p => {
                        console.log(this.items);

                        const exists = this.items.some(it => it.id_payment === (p.id_payment ?? p.id_payment));
                        if (!exists) {
                            // Empuja con las claves que tu tabla espera
                            this.items.push({
                                id_payment: p.id_payment ?? p.id,
                                shipping_number: p.shipping_number ?? '',
                                date_payment: p.date_payment ?? '',
                                week_number: p.week_number ?? '',
                                concept: p.concept ?? '',
                                value_payment: p.value_payment ?? p.amount ?? 0,
                                unpaid_amount: p.unpaid_amount ?? p.amount ?? 0,
                                value_payment_initials: p.value_payment_initials ?? (note.emit_id_currency_initials || 'CLP'),
                            });
                        }
                    });

                    // Seleccionar y recalcular el monto según tu lógica actual
                    this.items.forEach(row => {
                        if (ids.has(row.id_payment)) {
                            // re-usa tu toggle para mantener sumas consistentes
                            if (!this.selectedItems.has(row)) this.toggleSelection(row);
                        }
                    });
                    console.log(this.selectedItems)
                }, 1000);

            });

        },
        getClients() {
            this.$swal({
                title: 'Obteniendo clientes'
            });
            this.$swal.showLoading();
            const self = this;

            axios.get('/api/clients', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(response => {

                if (response.status == 200) {
                    self.clients = response.data.filter((client) => client.status == 1);

                    //self.clientesSelect = response.data.clienteEmpresa;
                    this.$swal.close();
                } else {
                    self.clients = [];
                }
            }).catch(function (error) {

                if (error.response.statusText == 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout'
                }
            });

        },

        async clientSelected(value) {
            //console.log('Selected Option:', value);
            this.selectedOption = value;
            const self = this;
            await self.getAR();
        },

    },
};
</script>

<style lang="css">
@import 'bootstrap';
@import 'datatables.net-bs5';

body {
    background-color: #f2f5f9;
}

.cont-proveedor {
    height: 300px;
    overflow-y: scroll;
}
</style>